import { Slider, ColorPicker, InputNumber } from 'antd';
import { Fragment } from 'react/jsx-runtime';
import { useSketchProperitesContext } from '../../../../../context/SketchPropertiesContext';
import './SketchConfig.scss';

const LineConfig = () => {
  const { strokeWidth, stroke, lineOpacity, setState } = useSketchProperitesContext();

  return (
    <Fragment>
      {/* Line Colour*/}
      <div className="sketch-config__row">
        <span className="sketch-config__label">COLOR</span>
        <ColorPicker
          value={stroke}
          onChange={(value) => {
            setState((prev) => ({
              ...prev,
              stroke: value.toHexString(),
            }));
          }}
          showText
        />
      </div>

      {/* Line weight */}
      <div className="sketch-config__row">
        <span className="sketch-config__label">WIDTH</span>
        <Slider className="sketch-config__flex" value={strokeWidth} onChange={(value) => setState((prev) => ({ ...prev, strokeWidth: value }))} />
        <InputNumber
          className="sketch-config__input"
          value={strokeWidth}
          onChange={(e) =>
            setState((prev) => ({
              ...prev,
              strokeWidth: Number(e),
            }))
          }
          min={0}
          max={100}
          placeholder="px"
        />
      </div>

      {/* Line Opacity */}
      <div className="sketch-config__row">
        <span className="sketch-config__label">OPACITY</span>
        <Slider className="sketch-config__flex" value={lineOpacity} onChange={(value) => setState((prev) => ({ ...prev, lineOpacity: value }))} />
        <InputNumber
          className="sketch-config__input"
          value={lineOpacity}
          onChange={(e) =>
            setState((prev) => ({
              ...prev,
              lineOpacity: Number(e),
            }))
          }
          min={0}
          max={100}
          placeholder="%"
        />
      </div>
    </Fragment>
  );
};

export default LineConfig;
